import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MenuService } from '../app.menu.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  providers: [Router]
})
export class MainComponent {



  constructor( ) {}


 


}
